export default __webpack_public_path__ + "static/media/Chrome.ff28adc5.png";